"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.StrategyAttributesContainer = void 0;
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const strategy_attributes_component_1 = require("./strategy-attributes.component");
const strategy_attributes_styles_1 = require("./strategy-attributes.styles");
const attributes_1 = require("../../client/attributes");
const hooks_1 = require("../../client/hooks");
const components_1 = require("../../components");
const context_1 = require("../../context");
const generic_1 = require("../../../generic");
const localization_1 = require("../../../localization");
const store_1 = require("../../../store");
const StrategyAttributesContainer = ({ onReEnrich, }) => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const selectedCatalogId = (0, store_1.useSelectedCatalogId)();
    const selectedStrategyNodeId = (0, store_1.useSelectedTreeNodeId)();
    const isProductTreeEditingAllowed = (0, store_1.useIsProductTreeEditingAllowed)();
    const isSelectedProjectStrategy = (0, store_1.useIsSelectedProjectStrategy)();
    const isReadOnly = (0, store_1.isStrategyReadOnly)(isProductTreeEditingAllowed, isSelectedProjectStrategy);
    const sortingItem = (0, store_1.useAttributesSort)();
    const filterState = (0, store_1.useAttributesFilter)();
    const { refetchProductCounters } = (0, hooks_1.useRefetchQueries)();
    const setSortingItem = (0, react_1.useCallback)((sortingItem) => dispatch((0, store_1.enrichAISetAttributesSort)(sortingItem)), [dispatch]);
    const { updateAggregationStatus } = (0, context_1.useProductTreeNodeReaggregationStatus)();
    (0, react_1.useEffect)(() => {
        if (selectedStrategyNodeId) {
            void updateAggregationStatus(() => refetchProductCounters({ selectedTreeNodeId: selectedStrategyNodeId }));
        }
    }, [refetchProductCounters, selectedStrategyNodeId, updateAggregationStatus]);
    const productLabelFilter = (0, react_1.useMemo)(() => {
        const { selectedAttributes, deselectedAttributes } = filterState;
        if (!selectedAttributes)
            return undefined;
        if (selectedAttributes === 'ALL') {
            if (deselectedAttributes.length > 0)
                return { label: { notIn: deselectedAttributes } };
            return undefined;
        }
        if (selectedAttributes.length === 0)
            return undefined;
        return { label: { in: selectedAttributes } };
    }, [filterState]);
    const productMeasureFilter = (0, react_1.useMemo)(() => {
        const { selectedAttributes, deselectedAttributes } = filterState;
        if (!selectedAttributes)
            return undefined;
        if (selectedAttributes === 'ALL') {
            if (deselectedAttributes.length > 0)
                return { some: { dimension: { notIn: deselectedAttributes } } };
            return undefined;
        }
        if (selectedAttributes.length === 0)
            return undefined;
        return { some: { dimension: { in: selectedAttributes } } };
    }, [filterState]);
    // TODO: Optimize data fetching to only call useGetAllAggregatedAttributes when reaggregation is complete.
    // Current issue: The 'skip' option clears previously loaded data instead of maintaining it during reaggregation.
    const { data: attributes, isLoading, isRefetching, pagination: { isLoadingMore, hasNextPage, onNextPage, }, error, } = (0, attributes_1.useGetAllAggregatedAttributes)({
        catalogId: selectedCatalogId,
        productTreeNodeId: selectedStrategyNodeId,
        sortingItem,
        productLabelFilter,
        productMeasureFilter,
    });
    if (error) {
        return react_1.default.createElement(strategy_attributes_styles_1.StyledErrorAlert, { severity: "error" }, error.message);
    }
    const shouldShowNoDataFallback = !!selectedStrategyNodeId
        && !isLoading
        && !isRefetching
        && !attributes.length;
    return (react_1.default.createElement(context_1.CheckedAttributesProvider, null, react_1.default.createElement(strategy_attributes_styles_1.StyledContainer, null, (isLoading || !selectedStrategyNodeId) && !isRefetching && (react_1.default.createElement("div", { className: "loading-overlay" }, react_1.default.createElement(components_1.PreviewSkeleton, { contrast: true }))), react_1.default.createElement(strategy_attributes_component_1.StrategyAttributes, { sortingItem: sortingItem, moreItemsLoading: isLoadingMore, hasNextPage: hasNextPage, onLoadMore: onNextPage, attributes: attributes, isReadOnly: isReadOnly, noDataFallback: shouldShowNoDataFallback && react_1.default.createElement(generic_1.NoDataFallback, { title: t({ key: 'NO_DATA_AVAILABLE' }) }), onSort: setSortingItem, onReEnrich: onReEnrich }))));
};
exports.StrategyAttributesContainer = StrategyAttributesContainer;
exports.default = exports.StrategyAttributesContainer;
